<template>
  <svg
    id="Layer_1"
    enable-background="new 0 0 511.375 511.375"
    height="512"
    viewBox="0 0 511.375 511.375"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    class="color"
  >
    <g>
      <path
        d="m511.375 255.687-57.89-64.273 9.064-86.045-84.65-17.921-43.18-75.011-79.031 35.32-79.031-35.32-43.18 75.011-84.65 17.921 9.063 86.045-57.89 64.273 57.889 64.273-9.063 86.045 84.65 17.921 43.18 75.011 79.031-35.321 79.031 35.321 43.18-75.011 84.65-17.921-9.064-86.045zm-148.497-55.985-128.345 143.792-89.186-89.186 21.213-21.213 66.734 66.734 107.203-120.104z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'VerifiedIcon'
}
</script>

<style lang="scss" scoped>

.profile{
  height: 28px;
  vertical-align: top;
  // margin-left: 8px;
  // fill: $color2;
}

</style>
